<template>
  <span>
    <span v-if="cards">
      <b-row v-for="(line, index) in cards" :key="'line' + index">
        <b-col v-for="(card, index) in line" :key="'card' + index">
          <b-card :title="card.value" class="center" :text-variant="card.variant ? card.variant : ''" :style="card.color ? `color:${card.color};` : ''">
            <b-card-text class="center">
              {{ card.label }}
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
    </span>
    <span v-else>
      <b-row v-for="line in [1,2]" :key="line">
        <b-col v-for="card in [1,2,3,4]" :key="card">
          <b-card class="center">
            <skeleton-loader height="28px" width="50px" style="margin-bottom: 14px;" />
            <br>
            <skeleton-loader height="19px" width="150px" style="margin-bottom: 14px;" />
          </b-card>
        </b-col>
      </b-row>
    </span>
  </span>
</template>

<script>
export default {
  name: 'StatisticsCards',
  props: ['cards']
}
</script>

<style scoped>
.center {
  text-align:center;
  color: black;
}
</style>